module.exports = __webpack_public_path__ + "static/media/home.4020ffe9.jpg";